import { Observable } from '../../Observable';
import { share } from '../../operator/share';
Observable.prototype.share = share;
//# sourceMappingURL=share.js.map